import { InfoBlock } from "./InfoBlock";

export const InfoBlockContainer = InfoBlock;
